var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 31,
    viewBox: "0 0 6 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0.90909L4.21591 21.8182H0.920455L0.636364 0.90909H4.5ZM2.56818 30.2273C1.86742 30.2273 1.2661 29.9763 0.764205 29.4744C0.262311 28.9725 0.0113637 28.3712 0.0113637 27.6705C0.0113637 26.9697 0.262311 26.3684 0.764205 25.8665C1.2661 25.3646 1.86742 25.1136 2.56818 25.1136C3.26894 25.1136 3.87027 25.3646 4.37216 25.8665C4.87405 26.3684 5.125 26.9697 5.125 27.6705C5.125 28.1345 5.00663 28.5606 4.76989 28.9489C4.54261 29.3371 4.23485 29.6496 3.84659 29.8864C3.4678 30.1136 3.04167 30.2273 2.56818 30.2273Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.685fe0f597020dc38e8f3b0192790a58.svg";
export { ForwardRef as ReactComponent };